// Styles
import classStyles from "../../index.module.css";

const RemarkHeader = () => {
  return (
    <div className={classStyles["header"]}>
      <h1 className={classStyles["title"]}>Remarks</h1>
    </div>
  );
};

export default RemarkHeader;
